import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  TargetDateGrid,
} from '../../components'

const Styles = require('./TargetDateSeries.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeries extends Component {
  render() {
    return <div styleName='main-grid'>
      {
        container.helmet(
          'Target date series',
          config.app.description,
          config.app.domain + config.routes.targetDateFunds
        )
      }
      <TargetDateGrid/>
    </div>
  }
}
